/**
 * Created by Arison on 2019/7/16.
 */
import  * as T from "./actionTypes"

export const changeTabIndex=(tabIndex)=>{
    return {
        type:T.CHANGE_PAY_TAB_SELECT,
        payload:tabIndex
    }
}